import { IUserProfile } from '../interfaces/user-profile.interface';

// Task 3 (closes ticket #20 + the client half of the clear ticket). Mirrors the backend
// whitelist accepted by `PUT api/user-profile/{profileId}` (`clearFields: string[]`) — unknown
// names are rejected with a 400, so this list must stay in lockstep with the backend whitelist.
export const CLEARABLE_PROFILE_FIELDS = [
    'bankName',
    'bankAccountNumber',
    'bankRoutingNumber',
    'bankBranch',
    'mobileBankingProvider',
    'mobileBankingAccount',
    'preferredDisbursementMethod',
    'employeeCode',
] as const;

export type ClearableProfileField = (typeof CLEARABLE_PROFILE_FIELDS)[number];

const isBlank = (value: unknown): boolean =>
    value === undefined || value === null || (typeof value === 'string' && value.trim() === '');

/**
 * A field is cleared iff it WAS non-blank on `original` and IS blank on `form`. Callers must
 * also strip every returned key from the payload body they send alongside this list — the
 * backend rejects a field that is both set and cleared in the same request with a 400.
 */
export function buildProfileClearFields(
    original: Partial<IUserProfile>,
    form: Record<string, unknown>
): string[] {
    return CLEARABLE_PROFILE_FIELDS.filter((field) => {
        const originalValue = (original as Record<string, unknown>)[field];
        const formValue = form[field];
        return !isBlank(originalValue) && isBlank(formValue);
    });
}
